import { render, staticRenderFns } from "./jak-kupic-akcje-spolek-z-newconnect.md?vue&type=template&id=3f8a92c2&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports